module.exports = __webpack_public_path__ + "static/media/NanumGothicExtraBold.20894075.ttf";